// @helpers
const { APIPost } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('constants/actionTypes');

const { download } = require('utilities/fileDownloadHelper');

// @actions
const { getPrecontractualInfoActive, getPrecontractualInfoActiveProduct } = require('actions/preContractualInfo');

const resetPDFMerge = () => {
    return {
        type: actionTypes.PDF_DOCUMENTS_MERGE_RESET,
    }
}

const requestPDFMergeSuccess = (response) => {
    return {
        type: actionTypes.PDF_DOCUMENTS_MERGE_SUCCESS,
        payload: {
            response
        }
    }
}
const requestPDFMergeError = (error) => {
    return {
        type: actionTypes.PDF_DOCUMENTS_MERGE_ERROR,
        payload: {
            error
        }
    }
}
const requestPDFMergeFetch = () => {
    return {
        type: actionTypes.PDF_DOCUMENTS_MERGE_REQUEST,
    }
}

const downloadMergedPDFeSuccess = () => {
    return {
        type: actionTypes.PDF_DOCUMENTS_DOWNLOAD_SUCCESS,
    }
}
const downloadMergedPDFError = () => {
    return {
        type: actionTypes.PDF_DOCUMENTS_DOWNLOAD_ERROR,
    }
}
const fetchPDFMerge = (documentList) => (dispatch)  => {
    const params = {
        header: {
            responseType: 'arraybuffer',
            accept: 'application/pdf'
        },
        query: documentList

    };

    dispatch(requestPDFMergeFetch());
    return APIPost({
        dispatch,
        endpoint: 'requestPreContractualsMergePDF',
        params
    })
        .then((response) => {
            dispatch(requestPDFMergeSuccess(response))
        })
        .catch((error) => {
            dispatch(requestPDFMergeError(error))
        });
}

const requestPDFMerge = (extraDocuments, productsToGetPrecontractuals = []) => (dispatch)  => {
        const promises = productsToGetPrecontractuals.map((product = {}) => {
            const { type, subtype, standard, id } = product;

            return dispatch(!!id
                ? getPrecontractualInfoActiveProduct(id)
                : getPrecontractualInfoActive(type, subtype, standard))
        })

        return Promise.all(promises)
            .then((preContactualDocumentsURLs) => {
                let preContractualDocuments = preContactualDocumentsURLs.map(url => ({
                        "fileName": "preContractualDocumentos",
                        url
                    })
                )
                return dispatch(fetchPDFMerge(preContractualDocuments.concat(extraDocuments)));
            })
};

const downloadMergedPDF = (pdfFileName) => (dispatch, getState) => {
    const precontractualsMergePdfs = getState().precontractualsMergePdfs;
    const mergedPreContractualsMergePdfs = precontractualsMergePdfs.get('mergedPDF');

    if (!!mergedPreContractualsMergePdfs) {
        download(mergedPreContractualsMergePdfs, pdfFileName, 'application/pdf');
        dispatch(downloadMergedPDFeSuccess());
    }
    else {
        dispatch(downloadMergedPDFError());
    }
}

const pollingPDFMerge = (operationProcessId) => (dispatch)  => {
    const params = {
        header: {
            responseType: 'arraybuffer',
            accept: 'application/pdf',
            version: 3
        },
        query: {operationProcessId}

    };

    dispatch(requestPDFMergeFetch());
    return APIPost({
        dispatch,
        endpoint: 'requestPreContractualsMergePDF',
        params
    })
        .then((response) => {
            dispatch(requestPDFMergeSuccess(response))
        })
        .catch((error) => {
            dispatch(requestPDFMergeError(error))
        });
}

module.exports = {
    pollingPDFMerge,
    requestPDFMerge,
    resetPDFMerge,
    downloadMergedPDF
};
